

/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import { makeData } from 'core/types/makeData'

import * as UtilityTypes from '../utilities/types'

import * as ObligationTypes from "./types"

export type ObligationsGetAllKey = ['people',string | undefined,'loans',string | undefined,'obligations',unknown];

export type ObligationsGetAllResponse = ObligationTypes.ResponseLocObligations;

export type ObligationsGetAllVariables = {
    personId: string | undefined;
    loanId: string | undefined;
    body?: void;
    query?: {
        periodId?: string;
        status?: "unfulfilled" | "overdue";
        fromDate?: string;
        toDate?: string;
        dueDate?: string;
        isOpen?: boolean;
    };
}

export const obligationsGetAll = makeData<
  ObligationsGetAllResponse,
  ObligationsGetAllKey,
  ObligationsGetAllVariables
>({
  method: 'get',
  name: 'obligationsGetAll',
  summary: "Get loan obligations",
  path: '/people/{personId}/loans/{loanId}/obligations',
  queryKey: ({query, personId,
loanId,}) => ['people',personId,'loans',loanId,'obligations', query],
})

export type ObligationCreateKey = ['people',string | undefined,'loans',string | undefined,'obligations',unknown];

export type ObligationCreateResponse = ObligationTypes.ResponseObligation;

export type ObligationCreateVariables = {
    personId: string | undefined;
    loanId: string | undefined;
    body?: ObligationTypes.RequestBodyObligationPost;
    query?: void;
}

export const obligationCreate = makeData<
  ObligationCreateResponse,
  ObligationCreateKey,
  ObligationCreateVariables
>({
  method: 'post',
  name: 'obligationCreate',
  summary: "Create obligation",
  path: '/people/{personId}/loans/{loanId}/obligations',
  queryKey: ({query, personId,
loanId,}) => ['people',personId,'loans',loanId,'obligations', query],
})

export type DrawObligationsGetAllKey = ['people',string | undefined,'loans',string | undefined,'draws',string | undefined,'obligations',unknown];

export type DrawObligationsGetAllResponse = ObligationTypes.ResponseObligations;

export type DrawObligationsGetAllVariables = {
    personId: string | undefined;
    loanId: string | undefined;
    drawId: string | undefined;
    body?: void;
    query?: {
        periodId?: string;
        status?: "unfulfilled" | "overdue";
        fromDate?: string;
        toDate?: string;
        dueDate?: string;
        isOpen?: boolean;
    };
}

export const drawObligationsGetAll = makeData<
  DrawObligationsGetAllResponse,
  DrawObligationsGetAllKey,
  DrawObligationsGetAllVariables
>({
  method: 'get',
  name: 'drawObligationsGetAll',
  summary: "Get draw obligations",
  path: '/people/{personId}/loans/{loanId}/draws/{drawId}/obligations',
  queryKey: ({query, personId,
loanId,
drawId,}) => ['people',personId,'loans',loanId,'draws',drawId,'obligations', query],
})

export type ObligationGetByIdKey = ['people',string | undefined,'loans',string | undefined,'obligations',string | undefined,unknown];

export type ObligationGetByIdResponse = ObligationTypes.ResponseLocObligation;

export type ObligationGetByIdVariables = {
    personId: string | undefined;
    loanId: string | undefined;
    obligationId: string | undefined;
    body?: void;
    query?: void;
}

export const obligationGetById = makeData<
  ObligationGetByIdResponse,
  ObligationGetByIdKey,
  ObligationGetByIdVariables
>({
  method: 'get',
  name: 'obligationGetById',
  summary: "Get loan obligation by ID",
  path: '/people/{personId}/loans/{loanId}/obligations/{obligationId}',
  queryKey: ({query, personId,
loanId,
obligationId,}) => ['people',personId,'loans',loanId,'obligations',obligationId, query],
})

export type ObligationUpdateKey = ['people',string | undefined,'loans',string | undefined,'obligations',string | undefined,unknown];

export type ObligationUpdateResponse = ObligationTypes.ResponseObligation;

export type ObligationUpdateVariables = {
    personId: string | undefined;
    loanId: string | undefined;
    obligationId: string | undefined;
    body?: ObligationTypes.RequestBodyObligationPut;
    query?: void;
}

export const obligationUpdate = makeData<
  ObligationUpdateResponse,
  ObligationUpdateKey,
  ObligationUpdateVariables
>({
  method: 'put',
  name: 'obligationUpdate',
  summary: "Update obligation",
  path: '/people/{personId}/loans/{loanId}/obligations/{obligationId}',
  queryKey: ({query, personId,
loanId,
obligationId,}) => ['people',personId,'loans',loanId,'obligations',obligationId, query],
})

export type DrawObligationGetByIdKey = ['people',string | undefined,'loans',string | undefined,'draws',string | undefined,'obligations',string | undefined,unknown];

export type DrawObligationGetByIdResponse = ObligationTypes.ResponseObligation;

export type DrawObligationGetByIdVariables = {
    personId: string | undefined;
    loanId: string | undefined;
    drawId: string | undefined;
    obligationId: string | undefined;
    body?: void;
    query?: void;
}

export const drawObligationGetById = makeData<
  DrawObligationGetByIdResponse,
  DrawObligationGetByIdKey,
  DrawObligationGetByIdVariables
>({
  method: 'get',
  name: 'drawObligationGetById',
  summary: "Get draw obligation by ID",
  path: '/people/{personId}/loans/{loanId}/draws/{drawId}/obligations/{obligationId}',
  queryKey: ({query, personId,
loanId,
drawId,
obligationId,}) => ['people',personId,'loans',loanId,'draws',drawId,'obligations',obligationId, query],
})

export type InternalObligationsGetAllKey = ['companies',string | undefined,'people',string | undefined,'loans',string | undefined,'obligations',unknown];

export type InternalObligationsGetAllResponse = ObligationTypes.ResponseObligations;

export type InternalObligationsGetAllVariables = {
    companyId: string | undefined;
    personId: string | undefined;
    loanId: string | undefined;
    body?: void;
    query?: {
        periodId?: string;
        status?: "unfulfilled" | "overdue";
        statuses?: Array<("all" | "active" | "pending" | "originated" | "declined" | "frozen" | "accelerated" | "chargedOff" | "paidOff" | "canceled")>;
        returnSeparated?: boolean;
    };
}

export const internalObligationsGetAll = makeData<
  InternalObligationsGetAllResponse,
  InternalObligationsGetAllKey,
  InternalObligationsGetAllVariables
>({
  method: 'get',
  name: 'internalObligationsGetAll',
  summary: "Get obligations",
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/obligations',
  queryKey: ({query, companyId,
personId,
loanId,}) => ['companies',companyId,'people',personId,'loans',loanId,'obligations', query],
})

export type InternalObligationCreateKey = ['companies',string | undefined,'people',string | undefined,'loans',string | undefined,'obligations',unknown];

export type InternalObligationCreateResponse = ObligationTypes.ResponseObligation;

export type InternalObligationCreateVariables = {
    companyId: string | undefined;
    personId: string | undefined;
    loanId: string | undefined;
    body?: ObligationTypes.RequestBodyObligationPost;
    query?: void;
}

export const internalObligationCreate = makeData<
  InternalObligationCreateResponse,
  InternalObligationCreateKey,
  InternalObligationCreateVariables
>({
  method: 'post',
  name: 'internalObligationCreate',
  summary: "Create obligation",
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/obligations',
  queryKey: ({query, companyId,
personId,
loanId,}) => ['companies',companyId,'people',personId,'loans',loanId,'obligations', query],
})

export type GetCompanyLoanObligationsKey = ['companies',string | undefined,'loans',string | undefined,'obligations',unknown];

export type GetCompanyLoanObligationsResponse = ObligationTypes.ResponseObligations;

export type GetCompanyLoanObligationsVariables = {
    companyId: string | undefined;
    loanId: string | undefined;
    body?: void;
    query?: {
        periodId?: string;
        status?: "unfulfilled" | "overdue";
    };
}

export const getCompanyLoanObligations = makeData<
  GetCompanyLoanObligationsResponse,
  GetCompanyLoanObligationsKey,
  GetCompanyLoanObligationsVariables
>({
  method: 'get',
  name: 'getCompanyLoanObligations',
  summary: "Get obligations without person ID",
  path: '/companies/{companyId}/loans/{loanId}/obligations',
  queryKey: ({query, companyId,
loanId,}) => ['companies',companyId,'loans',loanId,'obligations', query],
})

export type ObligationsRefreshPreviewForTimestampKey = ['companies',string | undefined,'people',string | undefined,'loans',string | undefined,'obligations','refresh-preview',unknown];

export type ObligationsRefreshPreviewForTimestampResponse = ObligationTypes.ResponseObligations;

export type ObligationsRefreshPreviewForTimestampVariables = {
    companyId: string | undefined;
    personId: string | undefined;
    loanId: string | undefined;
    body?: void;
    query?: {
        timestamp: string;
        transactionId?: string;
        autosum?: boolean;
    };
}

export const obligationsRefreshPreviewForTimestamp = makeData<
  ObligationsRefreshPreviewForTimestampResponse,
  ObligationsRefreshPreviewForTimestampKey,
  ObligationsRefreshPreviewForTimestampVariables
>({
  method: 'get',
  name: 'obligationsRefreshPreviewForTimestamp',
  summary: "Refresh obligations preview",
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/obligations/refresh-preview',
  queryKey: ({query, companyId,
personId,
loanId,}) => ['companies',companyId,'people',personId,'loans',loanId,'obligations','refresh-preview', query],
})

export type InternalObligationsRefreshKey = ['companies',string | undefined,'people',string | undefined,'loans',string | undefined,'obligations','refresh',unknown];

export type InternalObligationsRefreshResponse = ObligationTypes.ResponseObligations;

export type InternalObligationsRefreshVariables = {
    companyId: string | undefined;
    personId: string | undefined;
    loanId: string | undefined;
    body?: {
        eventIdForStatementDateReplay?: /** Public ID for the DLM event on the statement date that triggered the replay. */
        string | /** Public ID for the DLM event on the statement date that triggered the replay. */
        null;
    };
    query?: void;
}

export const internalObligationsRefresh = makeData<
  InternalObligationsRefreshResponse,
  InternalObligationsRefreshKey,
  InternalObligationsRefreshVariables
>({
  method: 'post',
  name: 'internalObligationsRefresh',
  summary: "Refresh obligations",
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/obligations/refresh',
  queryKey: ({query, companyId,
personId,
loanId,}) => ['companies',companyId,'people',personId,'loans',loanId,'obligations','refresh', query],
})

export type ObligationsRefreshKey = ['people',string | undefined,'loans',string | undefined,'obligations','refresh',unknown];

export type ObligationsRefreshResponse = ObligationTypes.ResponseObligations;

export type ObligationsRefreshVariables = {
    personId: string | undefined;
    loanId: string | undefined;
    body?: void;
    query?: void;
}

export const obligationsRefresh = makeData<
  ObligationsRefreshResponse,
  ObligationsRefreshKey,
  ObligationsRefreshVariables
>({
  method: 'post',
  name: 'obligationsRefresh',
  summary: "Refresh obligations",
  path: '/people/{personId}/loans/{loanId}/obligations/refresh',
  queryKey: ({query, personId,
loanId,}) => ['people',personId,'loans',loanId,'obligations','refresh', query],
})

export type RevokeOrReinstateGraceKey = ['companies',string | undefined,'people',string | undefined,'loans',string | undefined,'revoke-or-reinstate-grace',unknown];

export type RevokeOrReinstateGraceResponse = UtilityTypes.SingletonResponse & {
    data?: {};
};

export type RevokeOrReinstateGraceVariables = {
    companyId: string | undefined;
    personId: string | undefined;
    loanId: string | undefined;
    body?: {
        duePeriodId?: string;
        isReplay?: boolean;
    };
    query?: void;
}

export const revokeOrReinstateGrace = makeData<
  RevokeOrReinstateGraceResponse,
  RevokeOrReinstateGraceKey,
  RevokeOrReinstateGraceVariables
>({
  method: 'post',
  name: 'revokeOrReinstateGrace',
  summary: "Revoke or reinstate grace period",
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/revoke-or-reinstate-grace',
  queryKey: ({query, companyId,
personId,
loanId,}) => ['companies',companyId,'people',personId,'loans',loanId,'revoke-or-reinstate-grace', query],
})

export type InternalComputeBalancesForGraceKey = ['companies',string | undefined,'people',string | undefined,'loans',string | undefined,'compute-balances-for-grace',unknown];

export type InternalComputeBalancesForGraceResponse = void;

export type InternalComputeBalancesForGraceVariables = {
    companyId: string | undefined;
    personId: string | undefined;
    loanId: string | undefined;
    body?: void;
    query?: void;
}

export const internalComputeBalancesForGrace = makeData<
  InternalComputeBalancesForGraceResponse,
  InternalComputeBalancesForGraceKey,
  InternalComputeBalancesForGraceVariables
>({
  method: 'post',
  name: 'internalComputeBalancesForGrace',
  summary: "Compute balances for grace period",
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/compute-balances-for-grace',
  queryKey: ({query, companyId,
personId,
loanId,}) => ['companies',companyId,'people',personId,'loans',loanId,'compute-balances-for-grace', query],
})
